import ApiService from '../api.service';
import store from '../../store';
import router from '../../router';

const requestService = {
    GetContractInfo: async function(ContractRid) {
        try {
            let response = await ApiService.get('req/contractInfo', {
                params: {
                    ContractRid
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getKSKFullInfo: async function(KSKId) {
        try {
            let response = await ApiService.post('ksk/get_ksk_info', {
                iksk_rid: KSKId
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    GetContractContracts: async function(ContractRid, iLimit, iOffset) {
        try {
            let response = await ApiService.get('req/contractContracts', {
                params: {
                    ContractRid,
                    iLimit,
                    iOffset
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    GetContractObjects: async function(ContractRid, iLimit, iOffset, Filter) {
        try {
            let response = await ApiService.post('req/contractObjects', {
                params: {
                    ContractRid,
                    iLimit,
                    iOffset
                },
                Filter: Filter
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    GetContractObjectsFiltered: async function(ContractRid, iLimit, iOffset, Filter) {
        try {
            let response = await ApiService.post('req/contractObjectsFiltered', {
                params: {
                    ContractRid,
                    iLimit,
                    iOffset
                },
                Filter: Filter
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    GetObjFilterParams: async function(ContractRid) {
        try {
            let response = await ApiService.get('req/objFilterParams', {
                params: {
                    ContractRid
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    async getKSKHouses(iLimit, iOffset, Filter) {
        //console.log(Filter);
        const { data: response } = await ApiService.post('ksk/KSKHousesPeriodsFiltered', {
            params: {
                iLimit,
                iOffset,
                bIsDetailed: 1
            },
            Filter: Filter
        });
        return response.data;
    },
    async getKSKFilterList(KSKId) {
        try {
            let response = await ApiService.post('ksk/get_ksk_houses_filter', {
                iksk_rid: KSKId
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    async getContactTypes() {
        try {
            let response = await ApiService.get('refs/getContactTypes', {});
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    updateKSKInfo: async function(iksk_rid, nvcKSKData) {
        try {
            let response = await ApiService.post('req/updateKSKInfo', {
                params: {
                    iksk_rid
                },
                nvcKSKData
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    updateContacts: async function(iContractor_rid, nvcContacts) {
        try {
            let response = await ApiService.post('req/updateContacts', {
                params: {
                    iContractor_rid
                },
                nvcContacts
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    }
};

export { requestService };
